var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5H15V15H4.5V13.5ZM4.5 9H19.5V10.5H4.5V9Z",
    fill: "#A93AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortParagraph);
export default __webpack_public_path__ + "static/media/short-paragraph.0dfc22ef99baa43c0446f9a8b6a06130.svg";
export { ForwardRef as ReactComponent };